import { getMockValue } from '@f1/shared/src/data/_mockDataHelpers';
import createMockVarList from '@f1/shared/src/data/merchant/varList';

export const mockParseTsysVarPost = (_body, _params, _options) => {
  const [mockVarObj] = createMockVarList({ length: 1 });
  const mockAddress = getMockValue({ type: 'address' });
  return {
    nmiBoarding: {
      var: mockVarObj,
      auxiliaryNmiBoardingData: {
        country: 'US',
        city: mockAddress.cityName,
        state: mockAddress.stateCode,
        zip: mockAddress.zipCode,
        descriptor: getMockValue({ type: 'string' }),
        timeZoneDifferential: '123',
        customerServicePhone: getMockValue({ type: 'bePhone' }),
        isVisaAccepted: true,
        isMastercardAccepted: getMockValue({ type: 'boolean' }),
        isAmexAccepted: getMockValue({ type: 'boolean' }),
        isDiscoverAccepted: getMockValue({ type: 'boolean' }),
        isDinersAccepted: getMockValue({ type: 'boolean' }),
        isJcbAccepted: getMockValue({ type: 'boolean' }),
        isMaestroAccepted: getMockValue({ type: 'booean' })
      }
    }
  };
};

export default mockParseTsysVarPost;
